<template src="./index.html">
</template>
<script>
	import {getdata} from "./data.js"
    import { getShuijQiyInfo, query_login_status, startTaxGather } from '../../../../../api/organization.js';
    import bsdl from '../../../../common/bsdl/index.vue'
	export default {
		props: {
			choosetreeid:{
				type:String,
				default:''
			},
			companySettingdiag: {
				type: Boolean,
				default: false
			},
			companysend: {
				type: Number,
				default: 0
			},
			formlist: {
				type: Array,
				default: getdata().formlist
			},
			formdata:{
				type: Object ,
				default: getdata().formdata
			},
            rpaFormData:{
                type: Object ,
                default: getdata().rpaFormData
            },
			ruleForm:{
				type:Object ,
				default: getdata().ruleForm
			},
			ruledata:{
				type:Array ,
				default: getdata().ruledata
			},
			tableData:{
				type:Array,
				default: getdata().tableData
			},
			title:{
				type:String,
				default:getdata().title
			},
            province: {
                type: Array,
                default: []
            },
		},
        components: {
            bsdl,
        },
		data: function() {
			return {
                drawer: false,
                direction: 'rtl',
				adresslist: '',
				setmap: false,
				rules: getdata().rules,
				headData: getdata().headData,
				loginlist: [],
				list:getdata().maplist,
                tagName: "sys"
			}
		},
		watch: {
			companySettingdiag: function(indexVal, oldVal) {
				if (indexVal) {
					this.$nextTick(()=>{
                        if (this.$refs.ruleForm) {
                            this.$refs.ruleForm.clearValidate()
                        }
						if (this.$refs.taxform) {
                            this.$refs.taxform.clearValidate()
                        }
					})
				}
			},
			'ruleForm.dengjzclx':function(value){
			}
			
		},
		created() {
		},
		mounted() {
		},
		methods: {
            handleClose(done) {
                done();
            },
			handleChange(){

			},
            smsClose() {
                this.drawer = false;
            },
			xinxiCJ(){
				let params = {
					companyId:this.choosetreeid
				}
				startTaxGather(params).then(res=>{
					if(res.data.code==1){
						this.$emit('forlogin',{companyId:this.choosetreeid})
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			sjhq(){
				let prams = {
					companyId:this.choosetreeid
				}
				getShuijQiyInfo(prams).then(res=>{
					if(res.data.code==1){
						this.ruleForm.dianhhm = res.data.data.dianhhm
						this.ruleForm.faddbr= res.data.data.faddbr	
						this.ruleForm.jinbr= res.data.data.jinbr	
						this.ruleForm.dengjzclx= res.data.data.dengjzclx	
					}else{
						this.$message.error(res.data.msg)
					}
					
					
				})
			},
		out(e){
		},
			outchange(e) {
				this.$emit('outchanges', e)
				let companyLoginInfo = {}
				for(let a = 0 ; a <this.formlist.length ; a++){
					for(let key in this.formdata){
						if(this.formlist[a].prop==key){
							companyLoginInfo[key] = this.formdata[key]
							break
						}
					}
				}
				for(let key in this.formdata){
					let a = 0
					let b = 0
					for(let keys in companyLoginInfo){
						b++
						if(key != keys){
							a++
						}
					}
					if(a==b&&key != 'id'){
						this.formdata[key] = ''
					}
				}
			},
			getdatajy(e) {
				if (e) {
					this.setmap = true
				}
			},
			closediag(e) {
				this.$emit("closediag", '')
                this.tagName = "sys";
			},
			bsLogin() {
                query_login_status({companyId: this.rpaFormData.companyId}).then(res=>{
                    this.drawer = true;
                    if (res.data.code === 1) {
                        this.rpaFormData.loginStatus = true;
                    } else {
                        this.rpaFormData.loginStatus = false;
                    }
                })
            },
			confirm() {
				let setmin = false
				// this.ruleForm.suoshy.map((item,index)=>{
				// 	if(item==null){
				// 		this.ruleForm.suoshy.splice(index,1)
				// 	}
				// })
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						setmin = true
					}
				});
				if(this.companysend==1){
						if(this.ruleForm.suoshy){
							this.ruleForm.suoshy = this.ruleForm.suoshy[this.ruleForm.suoshy.length-1]
							
						}
						this.$emit("confirm",this.ruleForm, this.rpaFormData)
				}else if(this.companysend==0){
					if(this.ruleForm.shifbszt==1){
						this.$refs.taxform.submitForm()
					}else{
						this.setmap = true
					}
					if ( this.setmap) {
						if(this.ruleForm.shifbszt==1){
							let companyLoginInfo = {}
							for(let a = 0 ; a <this.formlist.length ; a++){
								for(let key in this.formdata){
									if(this.formlist[a].prop==key){
										companyLoginInfo[key] = this.formdata[key]
										break
									}
								}
							}
							this.ruleForm.companyLoginInfo = companyLoginInfo
						}
						if(this.ruleForm.suoshy){
							this.ruleForm.suoshy =this.ruleForm.suoshy[this.ruleForm.suoshy.length-1]
						}
						this.$emit("confirm", this.ruleForm, this.rpaFormData)
						this.setmap = false
					}
				}else{
						this.$emit("confirm", this.formdata, this.rpaFormData)
						this.setmap = false
				}
			}
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
